// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import AccordionController from "./accordion_controller"
import BalanceRefreshController from "./balance_refresh_controller"
import ClipboardController from "./clipboard_controller"
import ConsentGateController from "./consent_gate_controller"
import ConfirmController from "./confirm_controller"
import CountdownController from "./countdown_controller"
import DepositFormController from "./deposit_form_controller"
import DropdownController from "./dropdown_controller"
import FilterDropdownController from "./filter_dropdown_controller"
import EventMarketSelectorController from "./event_market_selector_controller"
import EventPriceChartController from "./event_price_chart_controller"
import HeroCarouselController from "./hero_carousel_controller"
import FlashController from "./flash_controller"
import HelloController from "./hello_controller"
import LegalDocumentController from "./legal_document_controller"
import LiveProbabilityController from "./live_probability_controller"
import MarketFiltersController from "./market_filters_controller"
import ModalController from "./modal_controller"
import NotificationBellController from "./notification_bell_controller"
import NotificationModalController from "./notification_modal_controller"
import PriceChartController from "./price_chart_controller"
import SearchDebounceController from "./search_debounce_controller"
import TradeModalController from "./trade_modal_controller"
import TradingPanelController from "./trading_panel_controller"
import WithdrawalFormController from "./withdrawal_form_controller"

application.register("accordion", AccordionController)
application.register("balance-refresh", BalanceRefreshController)
application.register("clipboard", ClipboardController)
application.register("consent-gate", ConsentGateController)
application.register("confirm", ConfirmController)
application.register("countdown", CountdownController)
application.register("deposit-form", DepositFormController)
application.register("dropdown", DropdownController)
application.register("filter-dropdown", FilterDropdownController)
application.register("event-market-selector", EventMarketSelectorController)
application.register("event-price-chart", EventPriceChartController)
application.register("hero-carousel", HeroCarouselController)
application.register("flash", FlashController)
application.register("hello", HelloController)
application.register("legal-document", LegalDocumentController)
application.register("live-probability", LiveProbabilityController)
application.register("market-filters", MarketFiltersController)
application.register("modal", ModalController)
application.register("notification-bell", NotificationBellController)
application.register("notification-modal", NotificationModalController)
application.register("price-chart", PriceChartController)
application.register("search-debounce", SearchDebounceController)
application.register("trade-modal", TradeModalController)
application.register("trading-panel", TradingPanelController)
application.register("withdrawal-form", WithdrawalFormController)
